import { render, staticRenderFns } from "./PersonalList.vue?vue&type=template&id=9b271e24&scoped=true"
import script from "./PersonalList.vue?vue&type=script&lang=js"
export * from "./PersonalList.vue?vue&type=script&lang=js"
import style0 from "./PersonalList.vue?vue&type=style&index=0&id=9b271e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b271e24",
  null
  
)

export default component.exports